<template>
  <div class="quiz-overview">
    <div v-if="quizStats" class="row no-gutters my-4">
      <HMStatCard
        class="col-12 col-md mt-2 mt-md-0 mr-md-4"
        :title="$t('QUIZZES.LABEL.SUBMISSIONS')"
        :clickable="false"
        :content="quizStats.total"
      />
      <HMStatCard
        class="col-12 col-md mt-2 mt-md-0 mr-md-4"
        :title="$t('QUIZZES.LABEL.VISITS')"
        :clickable="false"
        :content="quizStats.views"
      />
      <HMStatCard
        class="col-12 col-md mt-2 mt-md-0 mr-md-4"
        :title="$t('QUIZZES.LABEL.COMPLETION_RATE')"
        :clickable="false"
        :content="`${quizStats.completion_rate}%`"
      />
      <HMStatCard
        class="col-12 col-md mt-2 mt-md-0 mr-md-4"
        :title="$t('QUIZZES.LABEL.AVERAGE_SCORE')"
        :clickable="false"
        :content="`${quizStats.avg_score}%`"
      />
      <QuizSubmissionsTable
        v-if="quizStats"
        :quizId="quiz.id"
        :isGradable="quiz.is_gradable"
        :apiMethod="getSubmissionsData"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import { formatDate } from '@/web/utils/format';
import QuizSubmissionsTable from '@/web/views/admin/quizzes/QuizSubmissionsTable.vue';

export default Vue.extend({
  name: 'QuizOverview',
  components: {
    QuizSubmissionsTable,
  },
  data() {
    return {
      quizStats: null,
      tableFields: [
        {
          name: 'name',
          title: this.$t('QUIZZES.TABLE.NAME'),
          cssClass: 'h5',
        },
        {
          name: 'email',
          title: this.$t('QUIZZES.TABLE.EMAIL'),
        },
        {
          name: 'status',
          title: this.$t('QUIZZES.TABLE.STATUS'),
        },
        {
          key: 'created',
          title: this.$t('QUIZZES.TABLE.DATE_TAKEN'),
        },
        {
          name: 'delete',
          shrink: true,
          cssClass: 'p-0',
        },
        {
          name: 'action',
          shrink: true,
          cssClass: 'p-0',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
    }),
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    async getSubmissionsData() {
      const id = this.$route.params.id;
      this.quizStats = await this.$store.dispatch('quiz/getQuizStats', id);
      return {
        count: null,
        next: null,
        previous: null,
        results: [...this.quizStats.submissions],
      };
    },
  },
  async mounted() {
    try {
      const id = this.$route.params.id;
      this.quizStats = await this.$store.dispatch('quiz/getQuizStats', id);
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
        text: errorToMessage(
          error.response,
          `${this.$t(
            'QUIZZES.NOTIFICATIONS.FAILED_TO_LOAD_QUIZ_STATS'
          )}: ${error}`
        ),
        duration: -1,
      });
    }
  },
});
</script>
